/* eslint-disable react/prop-types */
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import style from "./style";

function NewTable({
  columns,
  rows,
  headerStyle,
  tableHeadCellStyle,
  align,
  hasAction,
  isSubscription,
  tableBodyTheme,
}) {
  return (
    <TableContainer
      sx={{
        ...style.container,
        maxHeight: "calc(100vh - 180px)", // Adjust based on your page layout
        overflow: "auto",
      }}
    >
      <Table aria-label="collapsible table" stickyHeader>
        <TableHead
          style={{
            paddingTop: "1.4rem",
            ...headerStyle,
          }}
        >
          <TableRow sx={{ padding: "1rem" }}>
            {columns.map((col) => (
              <TableCell
                key={col.displayName}
                align={align}
                rowSpan={col.rowspan ? col.rowSpan : 1}
                colSpan={col.colSpan ? col.colSpan : 1}
                style={
                  col.displayName === "Month" ||
                  col.displayName === "Exam" ||
                  col.key === "gohonzonType" ||
                  col.displayName === "S. No."
                    ? {
                        ...style.tableHeadCell,
                        textAlign: "start",
                        paddingLeft: "10px",
                        ...tableHeadCellStyle,
                      }
                    : {
                        ...style.tableHeadCell,
                        textAlign: "center",
                        ...tableHeadCellStyle,
                      }
                }
              >
                {col.displayName}
              </TableCell>
            ))}
            {hasAction ? <TableCell sx={style.tableHeadCell} /> : null}
          </TableRow>
        </TableHead>
        <TableBody
          sx={{
            ...style.tableBody,
            "& .MuiTableCell-root": {
              padding: "8px 8px 8px 8px",
            },
            "& .MuiTypography-root": {
              fontSize: "14px",
              color: "#000000",
            },
            "tr:nth-child(even)": {
              backgroundColor: !isSubscription
                ? { backgroundColor: tableBodyTheme }
                : "#E8EDF4",
            },
          }}
        >
          {rows}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const propTypes = {
  columns: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
  rows: PropTypes.arrayOf(PropTypes.element).isRequired,
  headerStyle: PropTypes.objectOf(),
  hasAction: PropTypes.bool,
  align: PropTypes.string,
  tableHeadCellStyle: PropTypes.objectOf(),
};

const defaultProps = {
  hasAction: false,
  align: "left",
  headerStyle: {},
  tableHeadCellStyle: {},
};

NewTable.propTypes = propTypes;
NewTable.defaultProps = defaultProps;

export default NewTable;
